// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@tps/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { informationStyles } from "@tps/Overrides/Widgets/InvoiceDetails/InvoiceDetailsInformation";
import { mergeWithCss } from "@tps/XDL/Utilities";
import { css } from "styled-components";

informationStyles.invoiceInformationGridContainer = {
    gap: 0,
};
informationStyles.informationGridContainer = {
    gap: 0,
    css: css`
        margin-bottom: 21px;
    `,
};
informationStyles.headingAndTextStyles = {
    ...xOrderInformationStyles.headingAndTextStyles,
};

informationStyles.statusGridItem = {
    width: [12, 12, 6, 6, 6],
};
informationStyles.invoiceDateGridItem = {
    width: [12, 12, 6, 6, 6],
};
informationStyles.termsGridItem = {
    width: [12, 12, 6, 6, 6],
};
informationStyles.poNumberGridItem = {
    width: [12, 12, 6, 6, 6],
};
informationStyles.salespersonGridItem = {
    width: [12, 12, 6, 6, 6],
};
informationStyles.shippingMethodGridItem = {
    width: [12, 12, 6, 6, 6],
};
informationStyles.dueDateGridItem = {
    width: [12, 12, 6, 6, 6],
};
informationStyles.vatNumberGridItem = {
    width: [12, 12, 6, 6, 6],
};
informationStyles.billingAddressGridItem = {
    width: [12, 12, 6, 6, 6],
};
informationStyles.shippingAddressGridItem = {
    width: [12, 12, 6, 6, 6],
};
informationStyles.orderNumberGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        align-items: center;
    `,
};

informationStyles.billingAddressStyle = {
    titleText: {
        css: css`
            display: none;
        `,
    },
    headerText: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            css: css`
                margin-bottom: 0;
                padding-bottom: 4px;
            `,
        }),
    },
    wrapper: {
        css: css`
            margin-bottom: 25px;
        `,
    },
};
informationStyles.shippingAddressStyle = {
    wrapper: {
        css: css`
            margin-bottom: 25px;
        `,
    },
    titleText: {
        css: css`
            display: none;
        `,
    },
    headerText: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            css: css`
                margin-bottom: 0;
                padding-bottom: 4px;
            `,
        }),
    },
};

informationStyles.orderNumberHeading = {
    css: css`
        line-height: 22px;
        font-size: 14px;
        text-transform: none;
        font-weight: bold;
        margin-right: 4px;
        white-space: nowrap;
    `,
};
